<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="40"
    height="40"
    viewBox="0 0 40 40"
    fill="none"
  >
    <path
      d="M15 18.75C21.9036 18.75 27.5 16.2316 27.5 13.125C27.5 10.0184 21.9036 7.5 15 7.5C8.09644 7.5 2.5 10.0184 2.5 13.125C2.5 16.2316 8.09644 18.75 15 18.75Z"
      stroke="currentColor"
      stroke-width="3"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M2.5 13.125V19.375C2.5 22.4812 8.09687 25 15 25C21.9031 25 27.5 22.4812 27.5 19.375V13.125"
      stroke="currentColor"
      stroke-width="3"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M10 18.2812V24.5312"
      stroke="currentColor"
      stroke-width="3"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M27.5 15.1123C33.2063 15.6342 37.5 17.9029 37.5 20.6248C37.5 23.7311 31.9031 26.2498 25 26.2498C21.9375 26.2498 19.1313 25.7545 16.9578 24.9311"
      stroke="currentColor"
      stroke-width="3"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M12.5 24.8875V26.875C12.5 29.9812 18.0969 32.5 25 32.5C31.9031 32.5 37.5 29.9812 37.5 26.875V20.625"
      stroke="currentColor"
      stroke-width="3"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M30 25.7812V32.0312"
      stroke="currentColor"
      stroke-width="3"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M20 18.2812V32.0312"
      stroke="currentColor"
      stroke-width="3"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
</template>

<script>
export default {
  name: "CoinsIcon",
};
</script>
